import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CheckForUpdateService {
	constructor(appRef: ApplicationRef, updates: SwUpdate) {
		// Bail out in environments where the service worker isn't available
		// (e.g. in-app browsers like Instagram/Facebook/TikTok WebViews, or dev mode).
		// Without this guard, `checkForUpdate()` throws
		// "Service workers are disabled or not supported by this browser".
		if (!updates.isEnabled) {
			return;
		}

		// Allow the app to stabilize first, before starting
		// polling for updates with `interval()`.
		const appIsStable$ = appRef.isStable.pipe(first((isStable) => isStable === true));
		const everyHour$ = interval(60 * 60 * 1000); // 1 hour
		const everyHourOnceAppIsStable$ = concat(appIsStable$, everyHour$);
		everyHourOnceAppIsStable$.subscribe(async () => {
			try {
				const updateFound = await updates.checkForUpdate();
				console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
			} catch (err) {
				console.error('Failed to check for updates:', err);
			}
		});
	}
}
